module.exports = {"member_tabular":{"manager":true}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json-resources/dashboard-configs.json
// module id = gnxg
// module chunks = 0